export class LoginId {
  constructor(municipalityCode, loginIdSuffix) {
    this.municipalityCode = municipalityCode;
    this.loginIdSuffix = loginIdSuffix;
  }
  prefix() {
    if (
      this.municipalityCode === "" ||
      typeof this.municipalityCode === "undefined"
    ) {
      return "";
    }
    return `ui${this.municipalityCode}`.slice(0, -1);
  }
  isEmpty() {
    return (
      this.municipalityCode === "" ||
      typeof this.municipalityCode === "undefined" ||
      this.loginIdSuffix === "" ||
      typeof this.loginIdSuffix === "undefined"
    );
  }
  toUserId() {
    if (
      this.loginIdSuffix === "" ||
      typeof this.loginIdSuffix === "undefined"
    ) {
      return "";
    }
    return `${this.prefix()}${this.loginIdSuffix}`;
  }
  static factory(municipalityCode, loginIdSuffix) {
    return new LoginId(municipalityCode, loginIdSuffix);
  }
}
